import React from 'react'

import { DataGrid, GridColDef } from '@mui/x-data-grid';
import { Paper } from '@mui/material';

export type GenerateEarlyWarningTypes = {
  id: number;
  buildingId: number;
  buildingType: string;
  buildingOwnerName: string;
  mobileNumber: string;
  areaOfRisk: string;
  maximumDepth: number;
  startTime: string;
  peakTime: string;
}

const columns: GridColDef[] = [
    { field: 'buildingId', headerName: 'Building ID (risk at)', flex: 1},
    { field: 'buildingType', headerName: 'Building type', flex: 1},
    { field: 'buildingOwnerName', headerName: 'Building owner name', flex: 1},
    { field: 'mobileNumber', headerName: 'Mobile number', flex: 1},
    { field: 'areaOfRisk', headerName: 'Area of risk', flex: 1},
    { field: 'maximumDepth', headerName: 'Maximum Depth (cm)', flex: 1},
    { field: 'startTime', headerName: 'Start Time', flex: 1},
    { field: 'peakTime', headerName: 'Peak Time', flex: 1},
];

const paginationModel = { page: 0, pageSize: 5 };

type DataTablePropsType = {
  data: GenerateEarlyWarningTypes[]
}

const DataTable = (props: DataTablePropsType) => {
  return (
    <Paper sx={{ height: '100%', width: '100%' }}>
      <DataGrid
        rows={props.data}
        columns={columns}
        initialState={{ pagination: { paginationModel } }}
        pageSizeOptions={[5, 10]}
        checkboxSelection
        sx={{ border: 0, backgroundColor: 'var(--background-color)', color: 'var(--text-color)',
          '& .MuiDataGrid-columnHeader': {
            backgroundColor: 'var(--background-color)'
          }
        }}
      />
    </Paper>
  )
}

export default DataTable